import { render, staticRenderFns } from "./EdgePopover.vue?vue&type=template&id=3c230bb2&scoped=true"
import script from "./EdgePopover.vue?vue&type=script&lang=js"
export * from "./EdgePopover.vue?vue&type=script&lang=js"
import style0 from "./EdgePopover.vue?vue&type=style&index=0&id=3c230bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c230bb2",
  null
  
)

export default component.exports